/* eslint-disable @next/next/no-img-element */
import { useState, useEffect } from 'react';
import http from 'utilities/http';
import PoductDetail from 'components/cong-dong/tao-bai-viet/product-detail';
import { Loader } from "components/loader";
import SeeMore from "components/seeMore";

export default function SlideImage({ setTag }) {
    const [searchValue, setSearchValue] = useState('');
    const [searchProduct, setsearchProduct] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState([12, 0]);
    const [currentPage, setCurrentPage] = useState(1);

    const fetchSearch = async (page) => {
        if (searchValue == '') {
            setCurrentPage(1);
            setPage([12, 0]);
            setsearchProduct([]);
            return;
        }
        if (page == 1) setCurrentPage(1);
        setLoading(true);
        const res = await http(`/rest/default/V1/catalogsearch/products/?keyword=${searchValue}&pageSize=12&currentPage=${page}`, {}, {});
        setPage([12, res?.total_count]);
        setsearchProduct(res?.items || []);
        setLoading(false);

        if (page <= 1) {
            setsearchProduct(res?.items);
        } else {
            setsearchProduct(searchProduct.concat(res?.items));
        }
    };

    useEffect(() => {
        if (currentPage <= 1) return;
        fetchSearch(currentPage);
    }, [currentPage]);

    return (
        <div className="photoPosts-content">
            <Loader loading={loading} />
            <h2 className="title">Chọn sản phẩm</h2>
            <div className="search-pro">
                <input className="form-control" type="text" onChange={(e) => setSearchValue(e.target.value)} onKeyUp={(e) => {
                    if (e.keyCode === 13) {
                        fetchSearch(1);
                    }
                }} />
                <button className="btn"><img src="/images/icon-search.svg" alt="" /></button>
            </div>
            {searchProduct.length > 0 ?
                <div className="listSearch">
                    <ul className="tag-list-search">
                        {searchProduct.map((item, index) => {
                            return <PoductDetail item={item} key={index} setTag={setTag} isAdd={true}></PoductDetail>;
                        })}
                        <li key="seemore" className="see-more pt-0"><SeeMore page={page} currentPage={currentPage} setCurrentPage={setCurrentPage}/></li>
                    </ul>
                </div>
                : <div className="noData">
                    <img src="/images/icon-no-data.svg" alt="" />
                    <p>Chưa có dữ liệu</p>
                </div>
            }
        </div>
    );
};